import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import './horizontalMenu.css'
import Typography from "@material-ui/core/Typography";
import {Badge, Icon, IconButton, makeStyles, Tooltip} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import SideBarTree from "../../../../../SideBarNew/SideBarTree";
import {TreeView} from "@material-ui/lab";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../Utils/lib";
import {getParamsFromString} from "../../../../Utils";
import styled from "styled-components"
import {useCurrentResolution} from "../../../../../../Hooks/useCurrentResolution";
import findByString from "../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import useWebSocket from "../../../../../../Hooks/useWebSocket";

const useStyles = makeStyles((theme) => ({
    treeViewRoot: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },
}))

const HorizontalMenu = props => {
    const {menu, onClick, screenName, dropdownItemStyles = {}, menuStyles, doActions} = props;
    const currentResolution = useCurrentResolution();
    let adaptiveWidth = typeof menuStyles.width === 'object' ? menuStyles.width[currentResolution] : menuStyles.width;
    return (
        <nav className={'navbar'} style={{
            width: adaptiveWidth
        }}>
            <MobileMenu
                screenName={screenName}
                menu={menu}
                onClick={onClick}
            />
            <ul className={'navbar-nav'}>
                {menu.map((menuItem, index) => (
                    <NavItem
                        key={index}
                        menuItem={menuItem}
                        onClick={onClick}
                        index={index}
                        screenName={screenName}
                        dropdownItemStyles={dropdownItemStyles}
                        doActions={doActions}
                    />))}
            </ul>
        </nav>
    );
};

HorizontalMenu.propTypes = {
    menu: PropTypes.array
};

export default HorizontalMenu;

// const StyledListItem = styled.div`
//   &:hover {
//     color: white; // <Thing> when hovered
//     background: #9e4c4c;
//   }
// `
const StyledListItem = styled.div(props => ({
    // ...props.styled.styles,
    '&:hover': {
        ...props.styled.hoverStyles
    },
}))

const NavItem = ({menuItem, onClick, index, screenName, dropdownItemStyles, doActions}) => {
    const {icon, label, badgeValue, tooltip} = menuItem.properties || {};
    const [customStyles, setCustomStyles] = useState(null);
    const {userLanguage} = useSelector(state => state.app);
    const {globalValues} = useSelector(state => state.jsonScreen);
    const multiLngLabel = multiLanguageValue(label, userLanguage);
    const menuItemStyles = menuItem.styles ? menuItem.styles[0] : {};
    const badge = badgeValue ? Number(getParamsFromString(badgeValue, globalValues, screenName)) || 0 : 0;

    useWebSocket(menuItem.events, doActions)

    useEffect(() => {
        const onLoad = (menuItem.events || []).find(e => e.event === 'onLoad');
        if (onLoad) {
            const actions = onLoad.actions;
            const setStyles = (actions || []).find(e => e.type === 'setStyles');
            if (setStyles) {
                setCustomStyles(getParamsFromString(setStyles.value, {...globalValues, userLanguage}, screenName))
            }
        }
    }, [JSON.stringify(globalValues), userLanguage, JSON.stringify(menuItem)])
    return (
        <li className={'nav-item'}
            style={{
                ...customStyles,
                padding: menuItemStyles.padding,
                fontSize: menuItemStyles.fontSize,
                color: menuItemStyles.color,
                background: menuItemStyles.background
            }}
            onClick={(e) => {
                e.stopPropagation();
                onClick(index)
            }}>
            <Tooltip title={tooltip ? tooltip : ''}>
                <Badge badgeContent={badge} color={'secondary'} showZero={false}>
                    <Typography style={{
                        display: 'flex'
                    }}>
                        {icon && (<Icon fontSize={"small"} style={{marginRight: 5, color: menuItemStyles.color}}>
                            {icon}
                        </Icon>)}
                        {multiLngLabel}
                    </Typography>
                </Badge>
            </Tooltip>
            {menuItem.sub && <div className={'nav-item-dropdown-container'}
                                  style={{
                                      background: dropdownItemStyles.background,
                                      color: dropdownItemStyles.color
                                  }}
            >
                {menuItem.sub.map((menuItem, subIndex) => {
                    const {label} = menuItem.properties || {};
                    const multiLngLabel = multiLanguageValue(label, userLanguage);
                    return (
                        <StyledListItem
                            styled={{
                                hoverStyles: dropdownItemStyles.hoverStyles,
                                styles: dropdownItemStyles
                            }}
                            key={`${index}.sub.${subIndex}`}
                            className={'dropdown-item'} onClick={(e) => {
                            e.stopPropagation();
                            onClick(`${index}.sub.${subIndex}`)
                        }}>
                            <Typography>
                                {multiLngLabel}
                            </Typography>
                        </StyledListItem>
                    )
                })}
            </div>}
        </li>
    )
}


const MobileMenu = ({menu, screenName, onClick}) => {
    const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false);
    const classes = useStyles();

    function toggleMobileMenu() {
        setIsOpenMobileMenu(prev => !prev);
    }

    return (
        <div className={'navbar-toggle-button'}>
            <IconButton onClick={toggleMobileMenu}>
                <Icon style={{color: '#fff'}}>
                    {isOpenMobileMenu ? 'menu_open' : 'menu'}
                </Icon>
            </IconButton>
            {isOpenMobileMenu && (
                <div className={'collapsed-container'}>
                    <TreeView
                        className={classes.treeViewRoot}
                        selected={''}
                        onNodeSelect={(e, nodeId) => {
                            onClick(nodeId)
                            const menuItem = findByString(menu, `${nodeId}`) || {properties: {}};
                            if (!menuItem.sub) {
                                toggleMobileMenu()
                            }
                        }}
                        defaultCollapseIcon={<ArrowDropDownIcon/>}
                        defaultExpandIcon={<ArrowRightIcon/>}
                        defaultEndIcon={<div style={{width: 24}}/>}
                    >
                        {SideBarTree({
                            menu,
                            onKeyDownItem: () => {
                            },
                            screenName,
                            toggleMobileMenu,
                            mobileMenu: true
                        })}
                    </TreeView>
                </div>
            )}
        </div>
    )
}